import { useEffect } from "react";
import { useState } from "react";
import CustomInput from "./Components/InputFields/CustomInput";
import LoaderComponent from "./Components/Loader/Loader";
import callApi from "./utils/apiCaller";
import { toast } from "react-toastify";
import Tab from "Common/Components/Tab/Tab";
import { Nav } from "Common/Components/Tab/Nav";
import PermissionSwitch from "./Components/PermissionLocks/PermissionSwitch";
import { showNotification } from "./utils/Notification";
import { v4 as uuidv4 } from 'uuid';

const MetaData = ({
  modelName = "blog",
  handleMetaChange,
  metaEdit,
  showError,
  toggleMeta,
  handleMetaData,
  loader,
}) => {

  const [isSavingMeta, setIsSavingMeta] = useState(false);
  const [permissionInfo, setPermissionInfo] = useState<PermissionInfo | null>(null);

useEffect(() => {
  const rawPermission = localStorage.getItem("permission");
  setPermissionInfo(rawPermission ? JSON.parse(rawPermission) : null);
}, []);

  const [jsonSchema, setJsonSchema] = useState(
    metaEdit.is_meta_edited ? metaEdit.updated_json_schema : metaEdit.json_schema || []
  );

  const [metaSchema, setMetaSchema] = useState([]);

  const [selectedSchema, setSelectedSchema] = useState("");

  const handleFirstLevelSchema = (index, keyName, keyValue) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[index][keyName] = keyValue;
    setJsonSchema(newJsonSchema);
  };

  const handleSecondLevelSchema = (
    schemaIndex,
    firstLevelIndex,
    keyName,
    keyValue
  ) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex][firstLevelIndex][keyName] = keyValue;
    setJsonSchema(newJsonSchema);
  };

  const handleThirdLevelSchema = (
    schemaIndex,
    firstLevelIndex,
    secondLevelIndex,
    keyName,
    keyValue
  ) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex][firstLevelIndex][secondLevelIndex][keyName] =
      keyValue;
    setJsonSchema(newJsonSchema);
  };

  useEffect(() => {
    setJsonSchema(metaEdit.is_meta_edited ? metaEdit.updated_json_schema : metaEdit.json_schema || []);
  }, [metaEdit.is_meta_edited, metaEdit.updated_json_schema, metaEdit.json_schema]);

  useEffect(() => {
    const fetchMetaSchema = async () => {
      const res = await callApi(`v1/content/seo/meta-schemas`, "get", {});
      if (res.status === "Success") {
        setMetaSchema(res.data.metaSchemas);
      }
    };

    fetchMetaSchema();
  }, []);

  const getConvertedKey = (value) => {
    return value === "String" ? "" : value;
  };

  const getMetaSchema = (metaSchema) => {
    let obj = { ...metaSchema };
    for (let key in obj) {
      if (typeof obj[key] === "object") {
        for (let innerKey in obj[key]) {
          if (typeof obj[key][innerKey] === "object") {
            for (let innerInnerKey in obj[key][innerKey]) {
              obj[key][innerKey][innerInnerKey] = getConvertedKey(
                obj[key][innerKey][innerInnerKey]
              );
            }
          } else {
            obj[key][innerKey] = getConvertedKey(obj[key][innerKey]);
          }
        }
      } else if (Array.isArray(obj[key])) {
        obj[key] = obj[key].map((item) => getConvertedKey(item));
      } else {
        obj[key] = getConvertedKey(obj[key]);
      }
    }
    console.log(metaSchema, obj, "obj");
    return obj;
  };

  const handleAddMetaSchema = async () => {
    let filteredSchema = metaSchema.filter(
      (item) => item.schema_type === selectedSchema
    );
    setJsonSchema([...jsonSchema, getMetaSchema(filteredSchema[0])]);
  };

  const getWebPageSchema = (schemaIndex, obj) => {
    return (
      <div className="col-span-12 p-2 card 2xl:col-span-12">
        <div>
          Schema Type - {obj.schema_type}{" "}
          <button
            className="text-red-500"
            onClick={() => handleRemoveOrganizationSchema(schemaIndex)}
          >
            Remove
          </button>
        </div>
        <CustomInput
          label="Name"
          name="name"
          type="text"
          value={obj.name || ""}
          placeholder="Name"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "name", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="URL"
          name="url"
          type="text"
          value={obj.url || ""}
          placeholder="URL"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "url", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="Description"
          name="description"
          type="text"
          value={obj.description || ""}
          placeholder="Description"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "description", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
      </div>
    );
  };

  const getBlogSchema = (schemaIndex, obj) => {
    return (
      <div className="col-span-12 p-2 card 2xl:col-span-12">
        <div>
          Schema Type - {obj.schema_type}{" "}
          <button
            className="text-red-500"
            onClick={() => handleRemoveOrganizationSchema(schemaIndex)}
          >
            Remove
          </button>
        </div>
        <CustomInput
          label="Name"
          name="name"
          type="text"
          value={obj.name || ""}
          placeholder="Name"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "name", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="URL"
          name="url"
          type="text"
          value={obj.url || ""}
          placeholder="URL"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "url", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="Description"
          name="description"
          type="text"
          value={obj.description || ""}
          placeholder="Description"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "description", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">Publisher</div>
          <CustomInput
            label="Publisher Name"
            name=""
            type="text"
            value={obj?.publisher?.name || ""}
            placeholder="Publisher Name"
            onChange={(e) =>
              handleSecondLevelSchema(
                schemaIndex,
                "publisher",
                "name",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
          <CustomInput
            label="Publisher Logo URL"
            name=""
            type="text"
            value={obj?.publisher?.logo?.url || ""}
            placeholder="Publisher Logo URL"
            onChange={(e) =>
              handleThirdLevelSchema(
                schemaIndex,
                "publisher",
                "logo",
                "url",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
        </div>
      </div>
    );
  };

  const getInnerObject = (obj) => {
    return Object.keys(obj).map((key) =>
      key === "@type" ? (
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          Schema Type: {obj[key]}
        </div>
      ) : typeof obj[key] === "object" ? (
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          {getInnerObject(obj[key])}
        </div>
      ) : Array.isArray(obj[key]) ? (
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">{key}</div>
          {obj[key].map((item, index) => (
            <div className="col-span-12 p-2 card 2xl:col-span-12">
              <CustomInput
                label={`Item ${index + 1}`}
                name={key}
                type="text"
                value={item || ""}
                placeholder={key}
                onChange={(e) => handleMetaChange(key, e.target.value)}
                isVersioned={false}
                versionedValue={null}
              />
            </div>
          ))}
        </div>
      ) : (
        <CustomInput
          label={key}
          name={key}
          type="text"
          value={obj[key] || ""}
          placeholder={key}
          onChange={(e) => handleMetaChange(key, e.target.value)}
          isVersioned={false}
          versionedValue={null}
        />
      )
    );
  };

  const getServiceSchema = (schemaIndex, obj) => {
    return (
      <div className="col-span-12 p-2 card 2xl:col-span-12">
        <div>
          Schema Type - {obj.schema_type}{" "}
          <button
            className="text-red-500"
            onClick={() => handleRemoveOrganizationSchema(schemaIndex)}
          >
            Remove
          </button>
        </div>
        <CustomInput
          label="Name"
          name="name"
          type="text"
          value={obj.name || ""}
          placeholder="Name"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "name", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="URL"
          name="url"
          type="text"
          value={obj.url || ""}
          placeholder="URL"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "url", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">Provider</div>
          <CustomInput
            label="Provider Name"
            name=""
            type="text"
            value={obj?.provider?.name || ""}
            placeholder="Provider Name"
            onChange={(e) =>
              handleSecondLevelSchema(
                schemaIndex,
                "provider",
                "name",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
        </div>
      </div>
    );
  };

  const getContactPageSchema = (schemaIndex, obj) => {
    return (
      <div className="col-span-12 p-2 card 2xl:col-span-12">
        <div>
          Schema Type - {obj.schema_type}{" "}
          <button
            className="text-red-500"
            onClick={() => handleRemoveOrganizationSchema(schemaIndex)}
          >
            Remove
          </button>
        </div>
        <CustomInput
          label="Name"
          name="name"
          type="text"
          value={obj.name || ""}
          placeholder="Name"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "name", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="URL"
          name="url"
          type="text"
          value={obj.url || ""}
          placeholder="URL"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "url", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Contact Point{" "}
            <button
              onClick={() =>
                handleAddContactPointInContactPageSchema(schemaIndex)
              }
            >
              Add
            </button>
          </div>
          {obj.contactPoint.map((item, index) => (
            <div className="col-span-12 p-2 card 2xl:col-span-12">
              <CustomInput
                label={`Contact Point ${index + 1}`}
                name=""
                type="text"
                value={item?.telephone || ""}
                placeholder={`Contact Point ${index + 1}`}
                onChange={(e) =>
                  handleThirdLevelSchema(
                    schemaIndex,
                    "contactPoint",
                    index,
                    "telephone",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Email ${index + 1}`}
                name=""
                type="text"
                value={item?.email || ""}
                placeholder={`Email ${index + 1}`}
                onChange={(e) =>
                  handleThirdLevelSchema(
                    schemaIndex,
                    "contactPoint",
                    index,
                    "email",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Contact Type ${index + 1}`}
                name=""
                type="text"
                value={item?.contactType || ""}
                onChange={(e) =>
                  handleThirdLevelSchema(
                    schemaIndex,
                    "contactPoint",
                    index,
                    "contactType",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Area Served ${index + 1}`}
                name=""
                type="text"
                value={item?.areaServed || ""}
                onChange={(e) =>
                  handleThirdLevelSchema(
                    schemaIndex,
                    "contactPoint",
                    index,
                    "areaServed",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <button
                onClick={() =>
                  handleRemoveContactPointInContactPageSchema(
                    schemaIndex,
                    index
                  )
                }
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const handleArrayInOrganizationSchema = (
    schemaIndex,
    keyName,
    index,
    keyValue1,
    keyValue2
  ) => {
    let newJsonSchema = [...jsonSchema];
    if (keyName === "sameAs") {
      newJsonSchema[schemaIndex].sameAs[index] = keyValue1;
    } else if (keyName === "award") {
      newJsonSchema[schemaIndex].award[index] = keyValue1;
    } else if (keyName === "address") {
      newJsonSchema[schemaIndex].address[index][keyValue1] = keyValue2;
    }
    setJsonSchema(newJsonSchema);
  };

  const handleSecondLevelSchemaInOrganizationSchema = (
    schemaIndex,
    keyName,
    keyValue1,
    keyValue2
  ) => {
    let newJsonSchema = [...jsonSchema];
    if (keyName === "contactPoint") {
      newJsonSchema[schemaIndex].contactPoint[keyValue1] = keyValue2;
    } else if (keyName === "founder") {
      newJsonSchema[schemaIndex].founder[keyValue1] = keyValue2;
    } else if (keyName === "numberOfEmployees") {
      newJsonSchema[schemaIndex].numberOfEmployees[keyValue1] = keyValue2;
    }
    setJsonSchema(newJsonSchema);
  };

  const handleRemoveOrganizationSchema = (schemaIndex) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema.splice(schemaIndex, 1);
    setJsonSchema(newJsonSchema);
  };

  const getOrganizationSchema = (schemaIndex, obj) => {
    return (
      <div className="col-span-12 p-2 card 2xl:col-span-12">
        <div>
          Schema Type - {obj.schema_type}{" "}
          <button
            className="text-red-500"
            onClick={() => handleRemoveOrganizationSchema(schemaIndex)}
          >
            Remove
          </button>
        </div>
        <CustomInput
          label="Name"
          name="name"
          type="text"
          value={obj.name || ""}
          placeholder="Name"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "name", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="URL"
          name="url"
          type="text"
          value={obj.url || ""}
          placeholder="URL"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "url", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="Logo"
          name="logo"
          type="text"
          value={obj.logo || ""}
          placeholder="Logo"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "logo", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="Description"
          name="description"
          type="text"
          value={obj.description || ""}
          placeholder="Description"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "description", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <CustomInput
          label="Founding Date"
          name="foundingDate"
          type="text"
          value={obj.foundingDate || ""}
          placeholder="Founding Date"
          onChange={(e) =>
            handleFirstLevelSchema(schemaIndex, "foundingDate", e.target.value)
          }
          isVersioned={false}
          versionedValue={null}
        />
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Founder Name
          </div>
          <CustomInput
            label="Founder Name"
            name="founder"
            type="text"
            value={obj.founder.name || ""}
            placeholder="Founder Name"
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "founder",
                "name",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
          <CustomInput
            label="Founder Job Title"
            name=""
            type="text"
            value={obj.founder.jobTitle || ""}
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "founder",
                "jobTitle",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
        </div>
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Address{" "}
            <button
              onClick={() => handleAddAddressInOrganizationSchema(schemaIndex)}
            >
              Add
            </button>
          </div>
          {obj.address.map((item, index) => (
            <div className="col-span-12 p-2 card 2xl:col-span-12">
              <CustomInput
                label={`Street Address ${index + 1}`}
                name=""
                type="text"
                value={item.streetAddress || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "address",
                    index,
                    "streetAddress",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Address Locality ${index + 1}`}
                name=""
                type="text"
                value={item.addressLocality || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "address",
                    index,
                    "addressLocality",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Address Region ${index + 1}`}
                name=""
                type="text"
                value={item.addressRegion || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "address",
                    index,
                    "addressRegion",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Postal Code ${index + 1}`}
                name=""
                type="text"
                value={item.postalCode || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "address",
                    index,
                    "postalCode",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <CustomInput
                label={`Address Country ${index + 1}`}
                name=""
                type="text"
                value={item.addressCountry || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "address",
                    index,
                    "addressCountry",
                    e.target.value
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <button
                onClick={() =>
                  handleRemoveAddressInOrganizationSchema(schemaIndex, index)
                }
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Contact Point
          </div>
          <CustomInput
            label="Telephone"
            name=""
            type="text"
            value={obj.contactPoint.telephone || ""}
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "contactPoint",
                "telephone",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
          <CustomInput
            label="Email"
            name=""
            type="text"
            value={obj.contactPoint.email || ""}
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "contactPoint",
                "email",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
          <CustomInput
            label="Contact Type"
            name=""
            type="text"
            value={obj.contactPoint.contactType || ""}
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "contactPoint",
                "contactType",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
        </div>
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Same As{" "}
            <button
              onClick={() => handleAddSameAsInOrganizationSchema(schemaIndex)}
            >
              Add
            </button>
          </div>
          {obj.sameAs.map((item, index) => (
            <div className="col-span-12 p-2 card 2xl:col-span-12">
              <CustomInput
                label={`Same As ${index + 1}`}
                name=""
                type="text"
                value={item || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "sameAs",
                    index,
                    e.target.value,
                    ""
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <button
                onClick={() =>
                  handleRemoveSameAsInOrganizationSchema(schemaIndex, index)
                }
              >
                Remove
              </button>
            </div>
          ))}
        </div>
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Number Of Employees
          </div>
          <CustomInput
            label="Value"
            name=""
            type="text"
            value={obj.numberOfEmployees.value || ""}
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "numberOfEmployees",
                "value",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
          <CustomInput
            label="Unit Text"
            name=""
            type="text"
            value={obj.numberOfEmployees.unitText || ""}
            onChange={(e) =>
              handleSecondLevelSchemaInOrganizationSchema(
                schemaIndex,
                "numberOfEmployees",
                "unitText",
                e.target.value
              )
            }
            isVersioned={false}
            versionedValue={null}
          />
        </div>
        <div className="col-span-12 p-2 card 2xl:col-span-12">
          <div className="col-span-12 p-2 card 2xl:col-span-12">
            Awards{" "}
            <button
              onClick={() => handleAddAwardInOrganizationSchema(schemaIndex)}
            >
              Add
            </button>
          </div>
          {obj?.award?.map((item, index) => (
            <div className="col-span-12 p-2 card 2xl:col-span-12">
              <CustomInput
                label={`Award ${index + 1}`}
                name=""
                type="text"
                value={item || ""}
                onChange={(e) =>
                  handleArrayInOrganizationSchema(
                    schemaIndex,
                    "award",
                    index,
                    e.target.value,
                    ""
                  )
                }
                isVersioned={false}
                versionedValue={null}
              />
              <button
                onClick={() =>
                  handleRemoveAwardInOrganizationSchema(schemaIndex, index)
                }
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const getObjectSchema = (schemaIndex, obj) => {
    if (obj.schema_type === "Blog") {
      return getBlogSchema(schemaIndex, obj);
    } else if (obj.schema_type === "WebPage") {
      return getWebPageSchema(schemaIndex, obj);
    } else if (obj.schema_type === "WebApplication") {
      return getWebPageSchema(schemaIndex, obj);
    } else if (obj.schema_type === "Service") {
      return getServiceSchema(schemaIndex, obj);
    } else if (obj.schema_type === "ContactPage") {
      return getContactPageSchema(schemaIndex, obj);
    } else if (obj.schema_type === "Organization") {
      return getOrganizationSchema(schemaIndex, obj);
    } else {
      return <div>No Schema Found</div>;
    }
  };

  const handleJsonSchemaData = async () => {
    console.log(jsonSchema, "jsonSchema");
    const res = await callApi(
      `v1/page/${metaEdit._id}/update-page-metaData`,
      "post",
      { json_schema: jsonSchema }
    );
    if (res.status === "Success") {
      toast.success("Meta Data Updated Successfully");
    }
  };

  const handleAddAddressInOrganizationSchema = (schemaIndex) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].address.push({
      "@type": "PostalAddress",
      streetAddress: "",
      addressLocality: "",
      addressRegion: "",
      postalCode: "",
      addressCountry: "",
    });
    setJsonSchema(newJsonSchema);
  };

  const handleRemoveAddressInOrganizationSchema = (schemaIndex, index) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].address.splice(index, 1);
    setJsonSchema(newJsonSchema);
  };

  const handleRemoveSameAsInOrganizationSchema = (schemaIndex, index) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].sameAs.splice(index, 1);
    setJsonSchema(newJsonSchema);
  };

  const handleRemoveAwardInOrganizationSchema = (schemaIndex, index) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].award.splice(index, 1);
    setJsonSchema(newJsonSchema);
  };

  const handleRemoveContactPointInContactPageSchema = (schemaIndex, index) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].contactPoint.splice(index, 1);
    setJsonSchema(newJsonSchema);
  };

  const handleAddSameAsInOrganizationSchema = (schemaIndex) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].sameAs.push("");
    setJsonSchema(newJsonSchema);
  };

  const handleAddAwardInOrganizationSchema = (schemaIndex) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].award.push("");
    setJsonSchema(newJsonSchema);
  };

  const handleAddContactPointInContactPageSchema = (schemaIndex) => {
    let newJsonSchema = [...jsonSchema];
    newJsonSchema[schemaIndex].contactPoint.push({
      "@type": "ContactPoint",
      telephone: "",
      email: "",
      contactType: "",
      areaServed: "",
    });
    setJsonSchema(newJsonSchema);
  };

const saveMetaInfo = async () => {
  try {
    setIsSavingMeta(true);

    let res;
    if (modelName === "blog") {
      res = await callApi(
        `v1/blog/${metaEdit._id}/update-blog-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "announcement") {
      res = await callApi(
        `v1/announcement/${metaEdit._id}/update-announcement-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "announcement") {
      res = await callApi(
        `v1/announcement/${metaEdit._id}/update-announcement-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "job") {
      res = await callApi(
        `v1/job/${metaEdit._id}/update-job-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "index") {
      res = await callApi(
        `v1/index/${metaEdit._id}/update-index-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "news") {
      res = await callApi(
        `v1/news/${metaEdit._id}/update-news-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "podcast") {
      res = await callApi(
        `v1/podcast/${metaEdit._id}/update-podcast-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }
    else if (modelName === "pressrelease") {
      res = await callApi(
        `v1/pressrelease/${metaEdit._id}/update-pressrelease-metadata`,
        "post",
        {
          page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema,
        }
      );
    }               
    else {
      res = await callApi(
        `v1/page/${metaEdit._id}/update-page-metaData`,
        "post",
        { page_title: metaEdit.updated_page_title,
          url: metaEdit.updated_url,
          meta_description: metaEdit.updated_meta_description,
          canonical_url: metaEdit.updated_canonical_url,
          json_schema: jsonSchema }
      );
    }

    setIsSavingMeta(false);

    if (res.status === "Success") {
      // Update metaSchema only for blog type
      if (modelName === "blog") {
        setMetaSchema((prev) =>
          Array.isArray(prev)
            ? prev.map((item) =>
                item._id === metaEdit._id
                  ? { ...item, is_meta_edited: true, ...metaEdit }
                  : item
              )
            : []
        );
      }

      toast.success("Meta Data Updated Successfully");
    } else {
      toast.error("Failed to update meta data");
    }
  } catch (error) {
    setIsSavingMeta(false);
    toast.error("An error occurred while saving meta info");
    console.error(error);
  }
};

  const handlePublishMetaInfo = async () => {
    if (modelName === "blog") {
      const res = await callApi(
        `v1/blog/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
    else if (modelName === "announcement") {
      const res = await callApi(
        `v1/announcement/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
    else if (modelName === "page") {
           const res = await callApi(
             `v1/page/${metaEdit?._id}/publish-metadata`,
             "post",
             {}
           );
           if (res && res?.status === "Success") {
             showNotification("Meta Data Published successfully", "success");
           }
         
         }
    else if (modelName === "job") {
      const res = await callApi(
        `v1/job/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
    else if (modelName === "index") {
      const res = await callApi(
        `v1/index/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
    else if (modelName === "news") {
      const res = await callApi(
        `v1/news/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
    else if (modelName === "podcast") {
      const res = await callApi(
        `v1/podcast/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
    else if (modelName === "pressrelease") {
      const res = await callApi(
        `v1/pressrelease/${metaEdit._id}/publish-metadata`,
        "post"
      );
      if (res.status === "Success") {
        toast.success("Meta Data Published Successfully");
      }
    }
  }

  console.log(metaEdit?.json_schema, metaEdit?.updated_json_schema, "jsonSchema");

    interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");
  const premissionInfo: PermissionInfo | null = rawPermission
    ? JSON.parse(rawPermission)
    : null;

    const getMetaFieldValue = (key: string) => {
  return metaEdit?.is_meta_edited
    ? metaEdit[`updated_${key}`] ?? metaEdit[key]
    : metaEdit[key];
};



  return (
    <>
      <div className="p-2">
        <Tab.Container defaultActiveKey="details">
          <PermissionSwitch
                          hasPermissions={premissionInfo?.permissions ?? []}
                          shouldHavePermissions={["blog:publish"]}
                          yes={
                            <div className="flex items-center justify-end">
            <button
              type="button"
              onClick={() => handlePublishMetaInfo()}
              className="px-4 py-2 mt-4 text-white bg-blue-500 rounded"
            >
              Publish
            </button>
          </div>
                          }
                          no={<span></span>}
                        />
                    
          <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
            <Nav.Item eventKey="details" className="group grow">
              <a
                href="#!"
                data-tab-toggle
                data-target="details"
                className="inline-block px-4 py-2 text-base w-full transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-white -mb-[1px]"
              >
                Details
              </a>
            </Nav.Item>
            <Nav.Item eventKey="jsonSchema" className="group grow">
              <a
                href="#!"
                data-tab-toggle
                data-target="jsonSchema"
                className="inline-block px-4 py-2 text-base w-full transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border border-transparent group-[.active]:text-custom-500 group-[.active]:border-slate-200 dark:group-[.active]:border-zink-500 group-[.active]:border-b-white dark:group-[.active]:border-b-zink-700 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-white -mb-[1px]"
              >
                Json Schema
              </a>
            </Nav.Item>
          </Nav>
          <Tab.Content className="mt-5 tab-content">
            <Tab.Pane eventKey="details" id="details">
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="mb-2 xl:col-span-12">
                  <CustomInput
                    label=" Page Title"
                    name="page_title"
                    type="text"
                    value={getMetaFieldValue("page_title") || ""}
                    onChange={(e) => handleMetaChange("page_title", e.target.value)}
                    placeholder="Enter Page Title"
                    isVersioned={!!metaEdit.is_meta_edited}
                    versionedValue={metaEdit.page_title}
                  />
                  {showError("page_title")}
                </div>
                <div className="mb-2 xl:col-span-12">
                  <CustomInput
                    label="Url"
                    name="url"
                    type="text"
                    value={getMetaFieldValue("url") || ""}
                    onChange={(e) => handleMetaChange("url", e.target.value)}
                    placeholder="Enter Url"
                    isVersioned={!!metaEdit.is_meta_edited}
                    versionedValue={metaEdit.url}
                  />
                  {showError("url")}
                </div>
                <div className="mb-2 xl:col-span-12">
                  <CustomInput
                    label=" Meta description"
                    name="meta_description"
                    type="text"
                    value={getMetaFieldValue("meta_description") || ""}
                    onChange={(e) => handleMetaChange("meta_description", e.target.value)}
                    placeholder="Enter Meta Description"
                    isVersioned={!!metaEdit.is_meta_edited}
                    versionedValue={metaEdit.meta_description}
                  />
                  {showError("meta_description")}
                </div>

                <div className="mb-2 xl:col-span-12">
                  <CustomInput
                    label=" Canonical Url"
                    name="canonical_url"
                    type="text"
                    value={getMetaFieldValue("canonical_url") || ""}
                    onChange={(e) => handleMetaChange("canonical_url", e.target.value)}
                    placeholder="Enter Canonical Url"
                    isVersioned={!!metaEdit.is_meta_edited}
                    versionedValue={metaEdit.canonical_url}
                  />
                  {showError("canonical_url")}
                </div>
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => toggleMeta()}
                >
                  Cancel
                </button>
                <button
                  onClick={() => saveMetaInfo()}
                  type="submit"
                  disabled={isSavingMeta}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {isSavingMeta ? <LoaderComponent /> : "Update Meta"}
                </button>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="jsonSchema" id="jsonSchema">
              <div className="grid grid-cols-12 my-2 gap-x-5">
                <div className="col-span-12 card 2xl:col-span-12">
                  <div className="p-4 ">
                    <form
                      className="create-form"
                      id="create-form"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                        <div className="xl:col-span-3">
                          <select
                            value={selectedSchema}
                            onChange={(e) => setSelectedSchema(e.target.value)}
                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                          >
                            <option value="">Select Schema</option>
                            {metaSchema?.map((item) => (
                              <option
                                key={item.schema_type}
                                value={item.schema_type}
                              >
                                {item.schema_type}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={handleAddMetaSchema}
                        className="px-4 py-2 mt-4 text-white bg-blue-500 rounded"
                      >
                        Add Meta Schema
                      </button>
                    </form>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-12 my-2 gap-x-5">
                <p>Old JSON Schema</p>
                {metaEdit?.is_meta_edited && metaEdit?.json_schema?.map((item, index) => (
                  <div className="col-span-12 card 2xl:col-span-12">
                    <div className="p-4 ">{getObjectSchema(index, item)}</div>
                  </div>
                ))}
              </div>
              <div className="grid grid-cols-12 my-2 gap-x-5">
                {/* {jsonSchema?.map((item, index) => (
                  <div className="col-span-12 card 2xl:col-span-12">
                    <div className="p-4 ">{getObjectSchema(index, item)}</div>
                  </div>
                ))} */}
                {Array.isArray(jsonSchema) && jsonSchema.map((item, index) => (
  <div className="col-span-12 card 2xl:col-span-12" key={index}>
    <div className="p-4">{getObjectSchema(index, item)}</div>
  </div>
))
}
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => toggleMeta()}
                >
                  Cancel
                </button>
                <button
                  onClick={() => saveMetaInfo()}
                  type="submit"
                  disabled={loader}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? <LoaderComponent /> : "Update Meta"}
                </button>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};

export default MetaData;
